module.exports = __webpack_public_path__ + "img/default6.f3cb9730.jpg";